export const config = {
    meta: {
        crew: 'stat',
        page: 'child-attendance',
        name: 'KinderConnectCapture',
        submit: {
            text: 'Confirm',
            requiredAdditionalData: [
                { name: 'photoBase64', type: 'string' },
                { name: 'signatureBase64', type: 'string' },
                { name: 'latitude', type: 'string' },
                { name: 'longitude', type: 'string' },
            ],
            successMessage: '',
            type: 'none',
            formType: 'submit',
        },
    },
    customHeader: true,
    version: 3,
    rows: [
        [{ type: 'custom-row', name: 'photoCapture' }],
        [{ type: 'custom-row', name: 'signatureCapture' }],
        [{ type: 'custom-row', name: 'geolocationCapture' }],
    ],
};
